// extracted by mini-css-extract-plugin
export default {"wrapper":"ow-z","viewport":"pw-z","container":"qw-z","slide":"rw-z"};